import { ThemeConfig } from 'antd';

const colorPrimary = '#003399';

export const theme: ThemeConfig = {
  token: {
    fontFamily: 'Outfit', // default application font
    fontSize: 16, // default application font size
    colorPrimary: colorPrimary, // primary antd color
    colorBorder: '#ececef', // all border colors
    colorText: '#4a4d53', // text color across app

    colorSuccess: '#047857',
    colorInfo: '#003399',
    colorWarning: '#D97706',
    colorError: '#EF4444',
  },
  components: {
    Badge: {
      fontSize: 11,
      lineHeight: 1.2,
      indicatorHeight: 20,
      borderRadius: 20,
      textFontSize: 11,
      textFontWeight: 500,
      padding: 1,
    },
    Input: {
      lineHeight: 2.4,
      colorText: 'var(--color-text-700)',
      colorBorder: 'var(--color-gray-600)',
      fontSize: 14,
      fontSizeLG: 15,
    },
    Button: {
      controlHeight: 40,
      fontSize: 15,
      fontWeight: 'medium',
      primaryShadow: 'none',
      defaultShadow: 'none',
      colorPrimaryHover: 'var(--color-primary-600)',
      borderRadius: 8,
      paddingInline: 16,
    },
    Dropdown: {
      controlItemBgHover: 'var(--color-gray-100)',
    },
    Menu: {
      subMenuItemBg: 'transparent', // used for sidebar numbers
      itemSelectedBg: '#e0e0e0',
      itemSelectedColor: '',
      groupTitleColor: '#5F6062',
      groupTitleFontSize: 12,
    },
    Radio: {
      buttonColor: '#5f6062',
      buttonCheckedBg: '#E5EAF5',
      controlHeight: 38,
    },
    Table: {
      fontSize: 14,
      fontWeightStrong: 500,
      rowHoverBg: 'var(--color-gray-100)',
      cellPaddingBlock: 10,
      cellPaddingInline: 16,
      headerBg: '#F9FAFB',
    },
    Layout: {
      bodyBg: 'var(--page-background)',
    },
    Select: {
      fontSize: 14,
      fontWeightStrong: 500,
      controlHeight: 36,
      colorText: '#5F6062',
      colorTextPlaceholder: 'var(--color-text-400)',
    },
    Steps: {
      titleLineHeight: 20,
    },
    Skeleton: {
      titleHeight: 10,
      paragraphLiHeight: 10,
      gradientFromColor: 'var(--color-primary-50)',
      gradientToColor: 'var(--color-primary-100)',
    },
    Switch: {
      colorPrimary: 'var(--color-emerald-500)',
      colorPrimaryHover: 'var(--color-emerald-400)',
      trackMinWidth: 52,
      trackHeight: 28,
      handleSize: 24,
    },
    Tabs: {
      colorText: 'var(--color-text-800)',
    },
    Upload: {
      colorBorder: 'var(--color-primary-200)',
      borderRadiusLG: 12,
    },
  },
};
